import { render, staticRenderFns } from "./Veracross.vue?vue&type=template&id=3f34c1c3&scoped=true"
import script from "./Veracross.vue?vue&type=script&lang=js"
export * from "./Veracross.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34c1c3",
  null
  
)

export default component.exports